import React from 'react';
import { BookOpen, Menu } from 'lucide-react';
import { scrollToPricing } from './utils';
export function TopBar() {
  return <nav className="bg-[#1e293b] text-white py-3 px-5 flex items-center justify-between sticky top-0 z-40 border-b border-white/10" data-id="element-206">
      <div className="flex items-center gap-2.5" data-id="element-207">
        <div className="w-8 h-8 bg-[#d4a017]/20 rounded-lg flex items-center justify-center" data-id="element-208">
          <BookOpen size={18} className="text-[#d4a017]" data-id="element-209" />
        </div>
        <span className="font-bold text-sm tracking-tight" data-id="element-210">SIC 360</span>
      </div>
      <button onClick={scrollToPricing} className="bg-[#d4a017] hover:bg-[#b88a14] text-[#1e293b] font-bold text-xs px-4 py-2 rounded-lg transition-colors hidden sm:block" data-id="element-211">
        Quiero acceso
      </button>
      <button className="sm:hidden text-white/70 hover:text-white transition-colors" onClick={scrollToPricing} data-id="element-212">
        <Menu size={24} data-id="element-213" />
      </button>
    </nav>;
}